import type { FC } from 'react';

import { type Role } from '@app/utils/protected-routes.utils';
import { Badge } from '@shared/components/ui';
import { textTransformRole } from '@shared/components/ui/custom/user-roles/user-roles.utils';

interface UserRolesProps {
  roles?: Role[];
}

export const UserRoles: FC<UserRolesProps> = ({ roles }) => {
  if (!roles) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2 h-auto max-w-full" data-testid="user-roles-root">
      {roles.map((role) => (
        <Badge
          key={role}
          variant="outline"
          data-testid={`user-roles-badge-${role.toLowerCase().replaceAll(/[^a-z0-9]+/g, '-')}`}
        >
          {textTransformRole(role)}
        </Badge>
      ))}
    </div>
  );
};
